/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type SelfDrivingSystemCardVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  vehicleStatusTelemetry?: {
    __typename?: 'VehicleStatusVehicleTelemetry'
    capabilities: {
      __typename?: 'VehicleStatusVehicleCapabilities'
      drivingMode: boolean
      gearState: boolean
    }
    sdsConnectionStatus: {
      __typename?: 'VehicleStatusConnectionSignal'
      connected: boolean
      updatedAt: string
    } | null
    drivingMode: {
      __typename?: 'VehicleStatusDrivingModeSignal'
      value: Types.VehicleStatusDrivingMode
      updatedAt: string
    } | null
    gearState: {
      __typename?: 'VehicleStatusGearStateSignal'
      gear: Types.VehicleStatusGearState
      updatedAt: string
    } | null
    speed: {
      __typename?: 'VehicleStatusFloatSignal'
      value: number
      updatedAt: string
    } | null
  } | null
}

export const SelfDrivingSystemCardVehicleFragmentDoc = gql`
    fragment SelfDrivingSystemCardVehicle on Vehicle {
  id
  vehicleStatusTelemetry @include(if: $withAdTelemetryData) {
    capabilities {
      drivingMode
      gearState
    }
    sdsConnectionStatus {
      connected
      updatedAt
    }
    drivingMode {
      value
      updatedAt
    }
    gearState {
      gear
      updatedAt
    }
    speed {
      value
      updatedAt
    }
  }
}
    `
